import enMeetings from './en';
import ruMeetings from './ru';

export default {
  en: {
    ...enMeetings,
  },
  ru: {
    ...ruMeetings,
  },
};
